import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "abbreviations" }
const _hoisted_2 = { class: "description" }
const _hoisted_3 = { class: "category-header" }
const _hoisted_4 = { class: "hint" }
const _hoisted_5 = { class: "entries" }
const _hoisted_6 = {
  key: 0,
  class: "empty"
}
const _hoisted_7 = { class: "add-row" }
const _hoisted_8 = {
  key: 0,
  class: "error"
}
const _hoisted_9 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_alert, {
      title: _ctx.$t('abbreviations.newUploadsOnly'),
      type: "info",
      closable: false,
      "show-icon": ""
    }, null, 8, ["title"]),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('abbreviations.description')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
      return (_openBlock(), _createElementBlock("div", {
        key: category.key,
        class: "category"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t(category.titleKey)), 1),
          _createVNode(_component_el_button, {
            type: "danger",
            link: "",
            disabled: _ctx.saving || _ctx.effectiveEntries(category).length === 0,
            onClick: ($event: any) => (_ctx.clearCategory(category))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('abbreviations.clearAll')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t(category.hintKey)), 1),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.effectiveEntries(category), (entry) => {
            return (_openBlock(), _createBlock(_component_el_tag, {
              key: entry.value,
              type: entry.isBuiltIn ? 'info' : 'success',
              closable: "",
              "disable-transitions": true,
              onClose: ($event: any) => (_ctx.removeEntry(category, entry))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(entry.value), 1)
              ]),
              _: 2
            }, 1032, ["type", "onClose"]))
          }), 128)),
          (_ctx.effectiveEntries(category).length === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('abbreviations.empty')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.newEntries[category.key],
            "onUpdate:modelValue": ($event: any) => ((_ctx.newEntries[category.key]) = $event),
            placeholder: _ctx.$t('abbreviations.addPlaceholder'),
            disabled: _ctx.saving,
            maxlength: "20",
            onKeyup: _withKeys(($event: any) => (_ctx.addEntry(category)), ["enter"])
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled", "onKeyup"]),
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: _ctx.saving,
            onClick: ($event: any) => (_ctx.addEntry(category))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('abbreviations.add')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        (_ctx.errors[category.key])
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.errors[category.key]), 1))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_button, {
        type: "primary",
        loading: _ctx.saving,
        disabled: !_ctx.hasUnsavedChanges,
        onClick: _ctx.save
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('generic.save')), 1)
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"]),
      _createVNode(_component_el_button, {
        disabled: _ctx.saving || !_ctx.hasSuppressedEntries,
        onClick: _ctx.restoreDefaults
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('abbreviations.restoreDefaults')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      (_ctx.hasUnsavedChanges)
        ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 0,
            type: "warning",
            "disable-transitions": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('abbreviations.unsavedChanges')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}